import React, { Component } from 'react';
import { translate } from '../services';
import { convertToUnicode, htmlParser } from '../util';
import { PropTypes } from 'prop-types';

export class HtmlComponent extends Component {
  render() {
    const { autoTranslate = true, className, item, tooltip, type } = this.props;
    const content = item && item.name ? item.name : item;
    const title = tooltip || '';
    const translatedAndUnicodedContent = convertToUnicode( autoTranslate ? translate( content ) : content );
    const translatedUnicodedAndCleanedTitle = htmlParser.removeHtmlTags( convertToUnicode( autoTranslate ? translate( title ) : title ) );
    if (translatedUnicodedAndCleanedTitle!='Fuse descriptions'){
    if( translatedAndUnicodedContent.includes( 'script' ) ) {

      console.warn( 'Scripts are not allowed' );
      return null;
    }}
    const innerHtml = { __html: translatedAndUnicodedContent };

    return React.createElement(
      type || 'span', 
      { className, title: translatedUnicodedAndCleanedTitle, dangerouslySetInnerHTML: innerHtml, dataTitle:translatedUnicodedAndCleanedTitle } 
    );
  }
}

HtmlComponent.propTypes = {
  autoTranslate: PropTypes.bool,
  className: PropTypes.string, 
  item: PropTypes.oneOfType( [PropTypes.string, PropTypes.shape( { 
    name: PropTypes.string 
  } ) ] ), 
  tooltip: PropTypes.string, 
  type: PropTypes.string
};